export const TAG_CATEGORIES = ['themes', 'typal'] as const
export type TagCategoryType = (typeof TAG_CATEGORIES)[number]
export const isTagCategoryType = (key?: string): key is TagCategoryType =>
  TAG_CATEGORIES.includes(key as TagCategoryType)

export const TAG_RENAMES = {
  defender: 'defenders',
  draw: 'card-draw',
  'eldrazi-tokens': 'eldrazi',
  'elemental-tokens': 'elementals',
  'elf-tokens': 'elves',
  enchantments: 'enchantress',
  'energy-counters': 'energy',
  'goblin-tokens': 'goblins',
  'golem-tokens': 'golems',
  'human-tokens': 'humans',
  'insect-tokens': 'insects',
  'knight-tokens': 'knights',
  lands: 'lands-matter',
  'm1-m1-counters': 'minus-1-minus-1-counters',
  'p1-p1-counters': 'plus-1-plus-1-counters',
  pod: 'birthing-pod',
  reanimate: 'reanimator',
  'saproling-tokens': 'saprolings',
  'soldier-tokens': 'soldiers',
  'spirit-tokens': 'spirits',
  'thopter-tokens': 'thopter',
  toughness: 'toughness-matters',
  walls: 'defenders',
  'warrior-tokens': 'warriors',
  'wolf-tokens': 'wolves',
  'zombie-tokens': 'zombies',
} as const
export type TagRenameType = keyof typeof TAG_RENAMES
export const isTagRenameType = (key?: string): key is TagRenameType => !!key && key in TAG_RENAMES

export type TagType = {
  count: number
  name: string
  slug: string
}
